import { createAsyncThunk } from "@reduxjs/toolkit";
import { InvestmentUpdate } from "@ifgengineering/client-invest-sdk";
import { logException } from "@helpers/logException/logException";
import { clientInvestSdk } from "@utils/clientInvestSdk";

const FETCH_INVESTMENT_UPDATES_API = "FETCH_INVESTMENT_UPDATES_API";
const MARK_INVESTMENT_UPDATE_VIEWED_API = "MARK_INVESTMENT_UPDATE_VIEWED_API";

export const fetchInvestmentUpdatesAPI = createAsyncThunk<InvestmentUpdate[]>(
  FETCH_INVESTMENT_UPDATES_API,
  async () => {
    try {
      const response = await clientInvestSdk.findInvestmentUpdates({});

      return response.data;
    } catch (e: any) {
      if (e.response?.status !== 401) {
        logException({
          tag: "fetchInvestmentUpdatesAPI",
          exception: e,
        });
      }

      return [];
    }
  }
);

export const markInvestmentUpdateViewedAPI = createAsyncThunk<string, string>(
  MARK_INVESTMENT_UPDATE_VIEWED_API,
  async (investmentUpdateId) => {
    try {
      await clientInvestSdk.markInvestmentUpdateAsViewed(investmentUpdateId);
      // Only resolve (and let the reducer mark isViewed) once the server has
      // recorded the view; otherwise reject so client and server stay in sync.
      return investmentUpdateId;
    } catch (e: any) {
      if (e.response?.status !== 401) {
        logException({
          tag: "markInvestmentUpdateViewedAPI",
          exception: e,
        });
      }
      throw e;
    }
  }
);
